import HomeIcon from "@mui/icons-material/Home";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { NavItem } from "components/Sidebar/navConfig";

const DriverNavConfig: NavItem[] = [
  { title: "Inicio", path: "/motorista", permissions: [], icon: HomeIcon },
  { title: "Pontualidade", path: "/motorista/pontualidade", permissions: [], icon: AccessTimeIcon },
  { title: "Quebras", path: "/motorista/quebras", permissions: [], icon: ReportProblemIcon },
  { title: "Entregas", path: "/motorista/entregas", permissions: [], icon: LocalShippingIcon },
  { title: "Caixas", path: "/motorista/caixas", permissions: [], icon: Inventory2Icon },
];

export default DriverNavConfig;